"use strict";
/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var VolumeChunkEncoding = /* @__PURE__ */ ((VolumeChunkEncoding2) => {
  VolumeChunkEncoding2[VolumeChunkEncoding2["RAW"] = 0] = "RAW";
  VolumeChunkEncoding2[VolumeChunkEncoding2["JPEG"] = 1] = "JPEG";
  VolumeChunkEncoding2[VolumeChunkEncoding2["COMPRESSED_SEGMENTATION"] = 2] = "COMPRESSED_SEGMENTATION";
  VolumeChunkEncoding2[VolumeChunkEncoding2["COMPRESSO"] = 3] = "COMPRESSO";
  VolumeChunkEncoding2[VolumeChunkEncoding2["PNG"] = 4] = "PNG";
  VolumeChunkEncoding2[VolumeChunkEncoding2["JXL"] = 5] = "JXL";
  return VolumeChunkEncoding2;
})(VolumeChunkEncoding || {});
export class VolumeChunkSourceParameters {
  url;
  encoding;
  sharding;
  static RPC_ID = "precomputed/VolumeChunkSource";
}
export class MeshSourceParameters {
  url;
  lod;
  static RPC_ID = "precomputed/MeshSource";
}
export var DataEncoding = /* @__PURE__ */ ((DataEncoding2) => {
  DataEncoding2[DataEncoding2["RAW"] = 0] = "RAW";
  DataEncoding2[DataEncoding2["GZIP"] = 1] = "GZIP";
  return DataEncoding2;
})(DataEncoding || {});
export var ShardingHashFunction = /* @__PURE__ */ ((ShardingHashFunction2) => {
  ShardingHashFunction2[ShardingHashFunction2["IDENTITY"] = 0] = "IDENTITY";
  ShardingHashFunction2[ShardingHashFunction2["MURMURHASH3_X86_128"] = 1] = "MURMURHASH3_X86_128";
  return ShardingHashFunction2;
})(ShardingHashFunction || {});
export class MultiscaleMeshMetadata {
  transform;
  lodScaleMultiplier;
  vertexQuantizationBits;
  sharding;
}
export class MultiscaleMeshSourceParameters {
  url;
  metadata;
  static RPC_ID = "precomputed/MultiscaleMeshSource";
}
export class SkeletonSourceParameters {
  url;
  metadata;
  static RPC_ID = "precomputed/SkeletonSource";
}
export class AnnotationSpatialIndexSourceParameters {
  url;
  sharding;
  static RPC_ID = "precomputed/AnnotationSpatialIndexSource";
}
export class AnnotationSourceParameters {
  rank;
  relationships;
  properties;
  byId;
  type;
  static RPC_ID = "precomputed/AnnotationSource";
}
export class IndexedSegmentPropertySourceParameters {
  url;
  sharding;
  static RPC_ID = "precomputed/IndexedSegmentPropertySource";
}
